<template>
  <div>
    <span>{{ schedule }}</span>
  </div>
</template>

<script>
import Common from '../../helper/Common';
export default {
  data() {
    return {
      schedule: ''
    };
  },
  mounted() {
    // Checking if data schedule is empty, if its true appending -- 
    this.schedule = this.data.schedule
    if (this.data.schedule === "") {
      this.schedule = "--"
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
